import { designTokens } from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { DealMainWorkflowVendorSub } from "~/components/common/deals/show/main/DealMainWorkflowVendorSub";
import { PartnerAssignmentResponseForm } from "~/components/common/deals/show/main/PartnerAssignmentResponseForm";
import { StatusBar } from "~/components/common/parts/status/StatusBar";
import { StatusReasonCard } from "~/components/common/statuses/StatusReasonCard";
import { StatusSwitcher } from "~/components/specifics/vendors/deals/[id]/statuses/StatusSwitcher";
import { DealContext } from "~/context/DealContext";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useDeals } from "~/hooks/vendors/useDeals";
import { useSessions } from "~/hooks/vendors/useSessions";
import { useStatuses } from "~/hooks/vendors/useStatuses";
import {
	getOriginVendor,
	getSelfDealVendor,
	getSubVendor,
	isOriginVendor
} from "~/models/DealVendorCompany";
import {
	getWithVendorStatuses,
	isCancelApplying,
	isCanceled,
	isCompleted,
	NOW_ACCEPTING
} from "~/models/Status";
import Styles from "./DealMainWorkflow.module.scss";
import { DealMainWorkflowVendorCancel } from "./DealMainWorkflowVendorCancel";

export function DealMainWorkflowVendor() {
	const id = useIdQueryHandler();
	const { data: deal, mutate: mutateDeal } = useDeals().show(id);
	const { data: statuses } = useStatuses().index();
	const { data: session } = useSessions().index();
	if (deal === null || session === null || statuses === null) {
		return null;
	}

	const isSubVendor = !isOriginVendor(deal, session.vendorCompany.id);
	const selfDealVendor = getSelfDealVendor(deal, session.vendorCompany.id);
	const subVendor = getSubVendor(deal);
	const isPendingAssignment =
		selfDealVendor?.partnerAssignmentResponseStatus === "pending";
	const canPartnerRespond =
		isSubVendor &&
		isPendingAssignment &&
		!isCompleted(deal.statusId) &&
		!isCanceled(deal.statusId);

	return (
		<DealContext.Provider value={{ deal, mutateDeal }}>
			{isCancelApplying(deal) ? (
				<>
					<DealMainWorkflowVendorCancel
						isSubVendor={isSubVendor}
						statuses={statuses}
					/>
					{/* 案件取り下げ申請中は、実施会社アサイン取り下げだけできるようにする */}
					{!isSubVendor && subVendor !== null ? (
						<DealMainWorkflowVendorSub />
					) : null}
				</>
			) : (
				<>
					{!isCanceled(deal.statusId) && (
						<>
							<Box mb={designTokens["spacing/m"]}>
								<Panel>
									<PanelHeader
										description={
											isSubVendor
												? `施工会社：${getOriginVendor(deal)?.name ?? ""}`
												: undefined
										}
										title={`${deal.companySetting.name}からの依頼`}
									/>
									<PanelBody>
										<StatusBar
											currentStatusId={deal.statusId}
											statuses={getWithVendorStatuses(statuses)}
										/>
									</PanelBody>
								</Panel>
							</Box>
							{deal.statusId !== NOW_ACCEPTING && <DealMainWorkflowVendorSub />}
						</>
					)}
					<StatusReasonCard deal={deal} />
					<div className={Styles.WorkflowCard}>
						{canPartnerRespond ? (
							<PartnerAssignmentResponseForm />
						) : (
							<StatusSwitcher statusId={deal.statusId} />
						)}
					</div>
				</>
			)}
		</DealContext.Provider>
	);
}
